/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { CompanyRegistrationResourceService, SubscriptionResourceService } from '@well/resource-services';
import { SubscriptionDtoModel, SubscriptionVisibilityDto } from '@well/domain';
import { Observable } from 'rxjs';
import { JsonApiResource } from '@irian-ro/abstract-resource';

@Injectable({
  providedIn: "root"
})
export class NewSubscriptionService {

  constructor(private subscriptionResourceService: SubscriptionResourceService,
              private companyRegistrationResourceService: CompanyRegistrationResourceService) {
  }

  onSave(resource: SubscriptionDtoModel) {

    return this.subscriptionResourceService.save(resource);

  }

  saveVisibility(subscriptionVisibilityDto: SubscriptionVisibilityDto): Observable<JsonApiResource<SubscriptionVisibilityDto, any>>{
    return this.companyRegistrationResourceService.addSubscriptionVisibility(subscriptionVisibilityDto);
  }

  saveCompanyDetailsAndAddSubscriptionVisibility(subscriptionVisibilityDto: SubscriptionVisibilityDto): Observable<JsonApiResource<SubscriptionVisibilityDto, any>>{
    return this.companyRegistrationResourceService.saveCompanyDetailsAndAddSubscriptionVisibility(subscriptionVisibilityDto);
  }

}
